import { GameSize } from "@/types/game";

/** Default inclusive max 0-based rank for each masonry tier after ranking. */
export const CATALOG_LARGE_MAX_RANK = 5;
export const CATALOG_MEDIUM_MAX_RANK = 22;

export const DEFAULT_LARGE_TIER_COUNT = CATALOG_LARGE_MAX_RANK + 1;
export const DEFAULT_MEDIUM_TIER_COUNT = CATALOG_MEDIUM_MAX_RANK - CATALOG_LARGE_MAX_RANK;

/**
 * Map catalog priority rank to masonry grid span (1×1, 2×2, 3×3).
 */
export function gridIconSizeForCatalogRank(
  rank: number | null | undefined,
  options?: {
    largeTierCount?: number;
    mediumTierCount?: number;
  }
): GameSize {
  const largeTierCount = options?.largeTierCount ?? DEFAULT_LARGE_TIER_COUNT;
  const mediumTierCount = options?.mediumTierCount ?? DEFAULT_MEDIUM_TIER_COUNT;
  const mediumMaxRank = largeTierCount + mediumTierCount - 1;

  if (rank == null || rank < 0) return GameSize.Small;
  if (rank < largeTierCount) return GameSize.Large;
  if (rank <= mediumMaxRank) return GameSize.Medium;
  return GameSize.Small;
}
